// extracted by mini-css-extract-plugin
export default {"wrap":"item__wrap__Ka"};